import React, { useState, useEffect } from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import { useHistory } from 'react-router-dom';
import logo from '../../asses/img/parkingl.png'
import Button from 'react-bootstrap/Button';
import axios from 'axios';
import { FaHome } from 'react-icons/fa';
import { URL_EMPLOYEE } from '../../constans/servidor';


import BuscadorComponen from '../../components/Mensualidades/Buscador'
import TableComponent from '../../components/Codigos/Buscador';
import FormularComponen from '../../components/Codigos/Formulario';
import FormularCodigoComponen from '../../components/Codigos/FormularioCodigos';
import * as ROUTES from '../../constans/rutas';

const ConveniosPage = () => {
  const [ventana, setVentana] = useState(1);
  const [Terminales, setTerminales] = useState('');
  const [opcionesTerminales, setOpcionesTerminales] = useState([]);
  const history = useHistory();

  const terminales = async () => {
    try {
      const res = await axios.get(`${URL_EMPLOYEE}/desenganchadas/getParkTerminales`)
      const respuesta = res.data['res'].filter((terminal, index, self) =>
        !self.slice(index + 1).some((other) => other.nombre_park === terminal.nombre_park)
      );
      setTerminales(
        respuesta.map((terminal) => ({
          value: terminal.cod_park,
          label: terminal.nombre_park,
        }))
      );

    } catch (error) {
    }


  }
  useEffect(() => {
    terminales()

  }, []);
  useEffect(() => {
    console.log(Terminales);

  }, [Terminales]);


  return (

    <>
      <Container className="contendor-Principal">

        <Row>
          <Col className='cont_logo' xs={12} sm={12} md={12} lg={12} xl={12}>
            <img className='logo' src={logo}></img>

            <p className="texto-slogan">Gestion de Convenios Virtuales</p>

          </Col>

        </Row>
        <Row className="justify-content-end ">
          <Col style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', fontSize: '15px' }} className='cont_logo' xs={12} sm={12} md={6} lg={4} xl={4}>

            <Button style={{ marginRight: '10px' }} variant="primary" onClick={() => history.push(ROUTES.HOME)}>
              <FaHome size={20} style={{ marginRight: '5px' }} />HOME
            </Button>
          </Col>

        </Row>
        <Row className="justify-content-end mbottom-20 menu">
          <Col className={ventana === 1 ? "menu_items2" : "menu_items"} xs={2} sm={2} md={2} lg={2} xl={2}>
            <button onClick={() => { setVentana(1) }}>Convenios</button>
          </Col>
          <Col className={ventana === 2 ? "menu_items2" : "menu_items"} xs={4} sm={4} md={2} lg={2} xl={2}>
            <button onClick={() => { setVentana(2) }}>Crear Convenios</button>
          </Col>
          <Col className={ventana === 3 ? "menu_items2" : "menu_items"} xs={4} sm={4} md={2} lg={2} xl={2}>
            <button onClick={() => { setVentana(3) }}>Crear Codigos</button>
          </Col>
        </Row>
      </Container>
      <Container>
        {ventana === 1 ? (
          <TableComponent Terminales={Terminales} ></TableComponent>
          // {Contrato}
        ) : null}
        {ventana === 2 ? (

          <FormularComponen Terminales={Terminales} ></FormularComponen>
          // {Contrato}
        ) : null}
        {ventana === 3 ? (

          <FormularCodigoComponen Terminales={Terminales} ></FormularCodigoComponen>
          // {Contrato}
        ) : null}

      </Container>

    </>
  )
}
export default ConveniosPage;